import { Text } from '@mantine/core';
import InternalError from '@percent/grants-nomination-form/assets/images/internal-error.png';
import NotFoundError from '@percent/grants-nomination-form/assets/images/not-found-error.png';

import { ErrorProps, ErrorVariant } from './Error.types';
import { Flex } from '@percent/lemonade';

const images: { [key in ErrorVariant]: string } = {
  [ErrorVariant.INTERNAL]: InternalError,
  [ErrorVariant.NOT_FOUND]: NotFoundError,
};

// TODO: Temporary for now
export const Error = ({ title, subtitle, variant, children }: ErrorProps) => {
  return (
    <Flex direction="column" align="center" gap={24} pt={48}>
      <img alt="error" src={images[variant]} />
      <Text fz="24" fw={600}>
        {title}
      </Text>
      {subtitle && <Text variant="subtitle1">{subtitle}</Text>}
      {children}
    </Flex>
  );
};

Error.variants = ErrorVariant;
